<template>
  <div class="Blok4b">

   <v-card>
    <v-card-title class="text-h5 grey lighten-5">
    <v-breadcrumbs :items="item">
       <template v-slot:item="{ item }">
       <v-breadcrumbs-item
          :href="goToRoute(item.href)"
          :disabled="item.disabled"
        >
        {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
    </v-card-title>
  </v-card>

    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      v-model="snackbar.show">
    
     <v-icon class="snackIcon">{{snackbar.icon}}</v-icon>

      {{ snackbar.message }}
    </v-snackbar>
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ $t("modultangkapandatahes4b") }}
      </v-card-title>
      <v-container>
        <v-form ref="formblok4b">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-bind:label="$t('hid')"
                outlined
                dense
                v-model="blok4bhid"
                :disabled="true"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2">
              <v-text-field
                v-bind:label="$t('ps')"
                v-model="blok4bpusingan"
                outlined
                dense
                :disabled="true"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field
                v-bind:label="$t('jumlahharian(rm)')"
                outlined
                dense
                :disabled="true"
                v-model="jumlahharian"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-bind:label="$t('jumlahedagang(rm)')"
                outlined
                dense
                :disabled="true"
                v-model="jumlahedagang"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-bind:label="$t('jumlahkeseluruhan(rm)')"
                outlined
                dense
                :disabled="true"
                v-model="jumlahkeseluruhan"
              ></v-text-field>
            </v-col>

            <v-col>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="light-blue white--text" @click="btnmodaltambahblok4b" v-bind="attrs" v-on="on">
                    <span class="material-icons">add</span>
                    {{ $t("tambah") }}
                  </v-btn>
                  </template>
                <span>Tambah Perbelanjaan</span>
              </v-tooltip>
            </v-col>

          </v-row>
        </v-form>
        
        <v-card-title>
          Senarai Perbelanjaan
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-card-title> 

          <v-data-table
            :headers="headers"
            :items="papardatablok4b"
            :search="search"
            :items-per-page="10"
            class="elevation-1"
            @click:row="btnmodalkemaskiniblok4b"
          >
            <template v-slot:item.no="{item,index}">
                  {{index+1}}
          </template>

          </v-data-table>
        
        <v-dialog v-model="modaltambahblok4b" persistent max-width="700px">
          <v-form ref="formtambahblok4b" v-model="valid" lazy-validation>
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                <span class="text-h5">{{ $t("tambahblok4b") }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>

                  <v-row>
                    <v-col cols="12" sm="8" v-show="paparlookupketeranganitem">
                      <v-autocomplete
                        outlined
                        dense
                        v-bind:label="$t('keteranganitem')"
                        :items="paparketeranganitem"
                        :item-text="item => item.KodItem +' - '+ item.Keterangan"
                        item-value="KodItem"
                        v-on:change="isidatakoditem('tambah')"
                        v-model="tambahketerangankoditem"
                        :rules="keteranganitemRules"
                      ></v-autocomplete>
                      <v-text-field
                        v-model="tambahketerangan"
                        v-show="false"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="4" v-show="paparinputblok4b">
                      <v-text-field
                        v-bind:label="$t('jenisbarang')"
                        outlined
                        dense
                        v-model="tambahjenisbarang"
                        :rules="jenisbarangRules"
                        :disabled="true"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row v-show="paparinputblok4b">
                    <v-col cols="12" sm="6">
                      <v-text-field
                        min="0"
                        maxlength="7"
                        v-bind:label="$t('rm')"
                        outlined
                        dense
                        v-model="tambahRM"
                        v-on:keyup="tukarkecurrentcy"
                        :error-messages="msgtambahRM"
                        required
                        @keypress="isNumber($event)"
                      ></v-text-field>
                    </v-col>

                    <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                mdi-alert-circle
              </v-icon>
            </template>
            <span>(Cth: Amaun (termasuk SST, LVGT, HVGT & dll)</span>
          </v-tooltip>

                    <v-col cols="12" sm="6">
                      <v-text-field
                        min="0"
                        maxlength="6"
                        v-bind:label="$t('kuantiti')"
                        v-model="tambahkuantiti"
                        outlined
                        dense
                        :rules="kuantitiRules"
                        @keypress="isNumber($event)"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-bind:label="$t('unit')"
                        v-model="tambahunit"
                        outlined
                        dense
                        :rules="unitRules"
                        :disabled="true"
                         @keypress="isNumber($event)"
                      ></v-text-field>
                    </v-col>

                     <v-col cols="12" sm="6">
                      <v-autocomplete
                        outlined
                        dense
                        min="0"
                        maxlength="1"
                        :items="tambahlookuphargasebenar"
                        v-bind:label="$t('hargasebenar')"
                        item-value="id"
                        :item-text="item => item.id +' - '+ item.desc"
                        v-model="tambahhargasebenar"
                        :rules="hargasebenarRules"
                        @keypress="isNumber($event)"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-autocomplete
                        outlined
                        dense
                        min="0"
                        maxlength="2"
                        :items="tambahlookuppuncalokasi"
                        v-bind:label="$t('puncalokasi')"
                        item-value="id"
                        :item-text="item => item.id +' - '+ item.desc"
                        v-model="tambahpuncalokasi"
                        :rules="puncalokasiRules"
                        @keypress="isNumber($event)"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-autocomplete
                        outlined
                        dense
                        min="0"
                        maxlength="2"
                        :items="tambahlookupmediumpembayaran"
                        v-bind:label="$t('mediumpembayaran')"
                        item-value="id"
                        :item-text="item => item.id +' - '+ item.desc"
                        v-model="tambahmediumpembayaran"
                        :rules="mediumpembayaranRules"
                        @keypress="isNumber($event)"
                      ></v-autocomplete>
                    </v-col>

                     <v-col cols="12" sm="6">
                      <v-autocomplete
                        outlined
                        dense
                        min="0"
                        maxlength="1"
                        :items="tambahlookupedagang"
                        v-bind:label="$t('edagang')"
                        item-value="id"
                        :item-text="item => item.id +' - '+ item.desc"
                        v-model="tambahedagang"
                        :rules="edagangRules"
                        @keypress="isNumber($event)"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-autocomplete
                        outlined
                        dense
                        min="0"
                        maxlength="2"
                        return-object
                        :items="listBulan"
                        v-bind:label="$t('bulanpembelian')"
                        v-model="bulan"
                        :rules="bulanRules"
                        :item-text="item => item.bulan +' - '+ item.tahun"
                        item-value="month"
                        @keypress="isNumber($event)"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-text-field
                        outlined
                        dense
                        v-bind:label="$t('catatan')"
                        :rules="catatanRules"
                        v-model="tambahcatatan"
                      ></v-text-field>
                    </v-col>
                    
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer>
                </v-spacer>

                <v-col cols="12" sm="8" class="text-left">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="grey darken-2 white--text" @click="resetpaparformtambahblok4b()" v-bind="attrs" v-on="on">
                      <span class="material-icons">reset_tv</span>
                        {{ $t("reset") }}
                      </v-btn>
                    </template>
                    <span>Reset Perbelanjaan</span>
                  </v-tooltip>
                </v-col>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="light-blue white--text" @click="btntambahkoditem()" v-bind="attrs" v-on="on">
                      <span class="material-icons">save</span>
                      {{ $t("simpan") }}
                    </v-btn>
                  </template>
                  <span>Simpan Perbelanjaan</span>
                </v-tooltip>
                
                <Overlay v-show="showOverlay" />

                &nbsp;
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="red accent-4 white--text" @click="modaltambahblok4b = false" v-bind="attrs" v-on="on">
                    <span class="material-icons">close</span>
                      {{ $t("tutup") }}
                    </v-btn>
                    </template>
                  <span>Tutup Perbelanjaan</span>
                </v-tooltip>

              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <v-dialog v-model="modalkemaskiniblok4b" persistent max-width="700px">
          <v-form ref="formkemaskiniblok4b" v-model="valid" lazy-validation>
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                <span class="text-h5">{{ $t("kemaskiniblok4b") }}</span>
              </v-card-title>
              <v-container>
                <v-text-field
                  v-model="kemaskiniBil"
                  v-show="false"
                ></v-text-field>

                <v-row>
                  <v-col cols="12" sm="8" v-show="paparlookupketeranganitem">
                    <v-autocomplete
                      outlined
                      dense
                      v-bind:label="$t('keteranganitem')"
                      :items="paparketeranganitem"
                      :item-text="item => item.KodItem +' - '+ item.Keterangan"
                      item-value="KodItem"
                      v-on:change="isidatakoditem('kemaskini')"
                      v-model="kemaskiniketerangankoditem"
                      :rules="keteranganitemRules"
                    ></v-autocomplete>
                    <v-text-field
                      v-model="kemaskiniketerangan"
                      v-show="false"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="4" v-show="paparinputblok4b">
                    <v-text-field
                      v-bind:label="$t('jenisbarang')"
                      outlined
                      dense
                      v-model="kemaskinijenisbarang"
                      :rules="jenisbarangRules"
                      :disabled="true"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row v-show="paparinputblok4b">
                  <v-col cols="12" sm="6">
                    <v-text-field
                      min="0"
                      maxlength="7"
                      v-bind:label="$t('rm')"
                      outlined
                      dense
                      v-model="kemaskiniRM"
                      v-on:keyup="tukarkecurrentcy"
                      :error-messages="msgkemaskiniRM"
                      required
                      @keypress="isNumber($event)"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      min="0"
                      maxlength="6"
                      v-bind:label="$t('kuantiti')"
                      v-model="kemaskinikuantiti"
                      outlined
                      dense
                      :rules="kuantitiRules"
                      @keypress="isNumber($event)"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-bind:label="$t('unit')"
                      v-model="kemaskiniunit"
                      outlined
                      dense
                      :rules="unitRules"
                      :disabled="true"
                      @keypress="isNumber($event)"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      outlined
                      dense
                      min="0"
                      maxlength="1"
                      :items="tambahlookuphargasebenar"
                      v-bind:label="$t('hargasebenar')"
                      :item-text="item => item.id +' - '+ item.desc"
                      item-value="id"
                      v-model="kemaskinihargasebenar"
                      :rules="hargasebenarRules"
                      @keypress="isNumber($event)"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      outlined
                      dense
                      min="0"
                      maxlength="2"
                      :items="tambahlookuppuncalokasi"
                      v-bind:label="$t('puncalokasi')"
                      :item-text="item => item.id +' - '+ item.desc"
                      item-value="id"
                      v-model="kemaskinipuncalokasi"
                      :rules="puncalokasiRules"
                      @keypress="isNumber($event)"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      outlined
                      dense
                      min="0"
                      maxlength="2"
                      :items="tambahlookupmediumpembayaran"
                      v-bind:label="$t('mediumpembayaran')"
                      :item-text="item => item.id +' - '+ item.desc"
                      item-value="id"
                      v-model="kemaskinimediumpembayaran"
                      :rules="mediumpembayaranRules"
                      @keypress="isNumber($event)"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      outlined
                      dense
                      min="0"
                      maxlength="2"
                      :items="tambahlookupedagang"
                      v-bind:label="$t('edagang')"
                      :item-text="item => item.id +' - '+ item.desc"
                      item-value="id"
                      v-model="kemaskiniedagang"
                      :rules="edagangRules"
                      @keypress="isNumber($event)"
                    ></v-autocomplete>
                  </v-col>

                   <v-col cols="12" sm="6">
                    <v-autocomplete
                      outlined
                      dense
                      min="0"
                      maxlength="2"
                      return-object
                      :items="listBulan"
                      v-bind:label="$t('bulanpembelian')"
                      :item-text="item => item.bulan +' - '+ item.tahun"
                      item-value="month"
                      v-model="kemaskinibulan"
                      :rules="bulanRules"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      outlined
                      dense
                      v-bind:label="$t('catatan')"
                      :rules="catatanRules"
                      v-model="kemaskinicatatan"
                    ></v-text-field>
                  </v-col>
                </v-row>

              </v-container>
              <v-card-actions>
                <v-spacer>
                </v-spacer>
                
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="light-blue white--text" @click="btnkemaskinikoditem()" v-bind="attrs" v-on="on">
                      <span class="material-icons">border_color</span>
                        {{ $t("kemaskini") }}
                    </v-btn>
                    </template>
                  <span>Kemaskini Perbelanjaan</span>
                  </v-tooltip>

                &nbsp;
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="purple darken-2 white--text" @click="padam(kemaskiniBil)" v-bind="attrs" v-on="on">
                    <span class="material-icons">delete</span>
                      {{ $t("padam") }}
                    </v-btn>
                    </template>
                  <span>Padam Perbelanjaan</span>
                </v-tooltip>
               
                &nbsp;
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">                
                    <v-btn color="red accent-4 white--text" @click="modalkemaskiniblok4b = false" v-bind="attrs" v-on="on">
                    <span class="material-icons">close</span>
                      {{ $t("tutup") }}
                    </v-btn>
                    </template>
                  <span>Tutup Perbelanjaan</span>
                </v-tooltip>


                <!-- Error Dialog -->
                <v-dialog v-model="errorDialog" width="500" height="200">
                  <v-card>
                    <v-alert dense outlined color="#C51162" type="error">
                      <strong>{{ errMessage }}</strong>
                    </v-alert>
                  </v-card>
                </v-dialog>

                <!-- Success Dialog -->
                <v-dialog v-model="successDialog" width="500" height="200">
                  <v-card color="success">
                    <v-alert dense outlined color="#C51162" type="success">
                      <strong>{{ successMessage }}</strong>
                    </v-alert>
                  </v-card>
                </v-dialog>


              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-container>
    </v-card>
  </div>
</template>
<script>
import hidServices from "@/services/lookupField";
const lookup = new hidServices();
import axios from "../../plugins/axios";
import i18n from "@/i18n";
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage(); 

//////////////////////////end import services//////////////
export default {
  
  Name: "Blok4b",
  setup() {},
  async beforeMount(){
        this.paparketeranganitem = await lookup.getlookupBlok4b();
    },
  computed: {
    tambahlookuphargasebenar() {
      return lookup.getHargasebenaranggaran();
    },
    tambahlookuppuncalokasi() {
      return lookup.getPuncalokasi();
    },
    tambahlookupmediumpembayaran() {
      return lookup.getMediumpembayaran();
    },
    tambahlookupedagang() {
      return lookup.getEdagang();
    },
    tambahlookupbulan() {
      return lookup.getBulanBlok4();
    },
  },
  data: () => ({
    papardatablok4b: [],
    dataPusingan:"",
    headers: [
      { text: i18n.t("Bil."), value: "no" },
      { text: i18n.t("koditem"), value: "KodItem" },
      { text: i18n.t("keteranganitem"), value: "Keterangan" },
      { text: i18n.t("jenisbarang"), value: "JenisBarang" },
      { text: i18n.t("rm"), value: "RMNEG" },
      { text: i18n.t("kuantiti"), value: "Kuantiti" },
      { text: i18n.t("unit"), value: "Unit" },
      { text: i18n.t("hargasebenar"), value: "SebenarAnggaran" },
      { text: i18n.t("puncalokasi"), value: "PuncaPembelian" },
      { text: i18n.t("mediumpembayaran"), value: "MediumBayaran" },
      { text: i18n.t("edagang"), value: "eDagang" },
      { text: i18n.t("bulanpembelian"), value: "Bulan" },
      { text: i18n.t("tahun"), value: "Tahun" },
      { text: i18n.t("catatan"), value: "Catatan" },
    ],
    successDialog: false,
    search: "",
    errorDialog: false,
    jumlahharian: "0.00",
    jumlahedagang: "0.00",
    jumlahkeseluruhan: "0.00",
    snackbar: "",
    tahunbulanhari: "",
    mindate: "",
    maxday: "",
    menu1: false,
    tambahkuantiti: "",
    tambahunit: "",
    tambahhargasebenar: "",
    tambahpuncalokasi: "",
    tambahRM: "",
    msgtambahRM: [],
    msgkemaskiniRM: [],
    tambahRM_HQ: "",
    valid: true,
    tambahjenisbarang: "",
    tambahkoditem: "",
    tambahketerangankoditem: "",
    tambahketerangan: "",
    tambahmediumpembayaran: "",
    tambahedagang: "",
    tambahcatatan: "",
    paparketeranganitem: [],
    paparinputblok4b: false,
    paparlookupketeranganitem: true,
    modaltambahblok4b: false,
    modalkemaskiniblok4b: false,
    paparbtn: false,
    blok4bhid: "",
    tambahbulan: "",
    blok4btahun: "",
    blok4bmingguan: "",
    blok4bpusingan: "",
    kemaskinikoditem: "",
    kemaskiniketerangankoditem: "",
    kemaskiniketerangan: "",
    kemaskinijenisbarang: "",
    kemaskiniRM: "",
    kemaskiniRM_HQ: "",
    kemaskinikuantiti: "",
    kemaskiniunit: "",
    kemaskinihargasebenar: "",
    kemaskinipuncalokasi: "",
    kemaskinimediumpembayaran: "",
    kemaskiniedagang: "",
    kemaskinibulan: "",
    kemaskinitambahtahun: "",
    kemaskinicatatan: "",
    kemaskiniBil: "",
    Ind: "",
    hari: [],
    bulan: [],
    listBulan: [],
    bulanMula : "",
    bulanAkhir : "",
    rules: {

    },
    koditemRules: [
      (v) => !!v || `${i18n.t("koditem")} ${i18n.t("adalahdiperlukan")}`,
    ],


    keteranganitemRules: [
      (v) => !!v || `${i18n.t("keteranganitem")} ${i18n.t("adalahdiperlukan")}`,
    ],
    jenisbarangRules: [
      (v) => !!v || `${i18n.t("jenisbarang")} ${i18n.t("adalahdiperlukan")}`,
    ],
    rmRules: [(v) => !!v || `${i18n.t("rm")} ${i18n.t("adalahdiperlukan")}`],
    kuantitiRules: [
      (v) => !!v || `${i18n.t("kuantiti")} ${i18n.t("adalahdiperlukan")}`,
    ],
    unitRules: [
      (v) => !!v || `${i18n.t("unit")} ${i18n.t("adalahdiperlukan")}`,
    ],
    hargasebenarRules: [
      (v) => !!v || `${i18n.t("hargasebenar")} ${i18n.t("adalahdiperlukan")}`,
    ],
    puncalokasiRules: [
      (v) => !!v || `${i18n.t("puncalokasi")} ${i18n.t("adalahdiperlukan")}`,
    ],
    mediumpembayaranRules: [
      (v) =>
        !!v || `${i18n.t("mediumpembayaran")} ${i18n.t("adalahdiperlukan")}`,
    ],
    edagangRules: [
      (v) => !!v || `${i18n.t("edagang")} ${i18n.t("adalahdiperlukan")}`,
    ],
    bulanRules: [
      // (v) => !!v || `${i18n.t("bulan")} ${i18n.t("adalahdiperlukan")}`,
      // v => (v && v.length == 2) || '2 digit sahaja dibenarkan',
    ],
    tahunRules: [
      (v) => !!v || `${i18n.t("tahun")} ${i18n.t("adalahdiperlukan")}`,
      v => (v && v.length == 4) || '4 digit sahaja dibenarkan',
    ],
    catatanRules: [
      (v) => !!v || `${i18n.t("catatan")} ${i18n.t("adalahdiperlukan")}`,
    ],

     ///////////link untuk ke page/////////////////////
    item: [
      {
        text: "Paparan Utama",
        disabled: false,
        href: "paparanutama",
      },
      {
        text: "BLOK 3 (PreCode)",
        disabled: false,
        href: "BLK3PreCode",
      },
      {
        text: "BLOK 3",
        disabled: false,
        href: "blk3",
      },
      {
        text: "BLOK 4a",
        disabled: false,
        href: "Blok4a",
      },
      {
        text: "BLOK 4b",
        disabled: true,
        href: "Blok4b",
      },
      {
        text: "BLOK 4c",
        disabled: false,
        href: "Blok4c",
      },
      {
        text: "BLOK 7",
        disabled: false,
        href: "blk7",
      },
       {
        text: "BLOK 7 (Imbangan)",
        disabled: false,
        href: "Blok7Imbangan",
      },
       {
        text: "Pengesahan (Imbangan)",
        disabled: false,
        href: "PengesahanImbangan",
      },
    ],

  }),
  mounted() {
    this.paparanpermulaan();
    this.tambahcatatan = "-";
  },
  methods: {
    goToRoute(url) {
      return `/${i18n.locale}/${url}/${this.$route.params.hid}`;
    },
     isNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    async paparmodaltambah () {
      this.modaltambahblok4b = true
      this.modalkemaskiniblok4b = false
    },

    async hapusblok4b() {
      // alert(this.kemaskiniBil)
      if (confirm(`${i18n.t("hapus")}`)) {
        await axios
          .post(`${process.env.VUE_APP_API_URL}/blk/hapusdatablok4b`, {
            blok4bbil: this.kemaskiniBil,
          })
          .then((res) => {
            console.log(res);
            if (res.data.result === 1) {
              this.snackbar = {
                message: i18n.t("berjaya"),
                timeout: 2000,
                color: "success",
                show: true,
              };
              this.cariblok4b();
            } else {
              this.snackbar = {
                message: i18n.t("cubalagi"),
                timeout: 2000,
                color: "red darken-4",
                show: true,
              };
            }
          });
      }
    },

    async btnkemaskinikoditem() {
      if (this.$refs.formkemaskiniblok4b.validate()) {
      const datakemaskini = {
        blok4bhid: this.blok4bhid,
        kemaskiniBil: this.kemaskiniBil,
        kemaskiniketerangankoditem: this.kemaskiniketerangankoditem,
        kemaskiniketerangan: this.kemaskiniketerangan,
        kemaskinijenisbarang: this.kemaskinijenisbarang,
        kemaskiniRM: this.RMNEG,
        kemaskiniRM_HQ: this.RMHQ,
        kemaskinikuantiti: this.kemaskinikuantiti,
        kemaskiniunit: this.kemaskiniunit,
        kemaskinihargasebenar: this.kemaskinihargasebenar,
        kemaskinipuncalokasi: this.kemaskinipuncalokasi,
        kemaskinimediumpembayaran: this.kemaskinimediumpembayaran,
        kemaskinibulan: this.kemaskinibulan.bulan,
        kemaskinitambahtahun: this.kemaskinibulan.tahun,
        kemaskiniedagang: this.kemaskiniedagang,
        kemaskinicatatan: this.kemaskinicatatan,
        Ind: this.Ind,
      };
      let vali = 0
        if (this.kemaskiniRM === '') {
          vali++
          this.msgkemaskiniRM = `${i18n.t("rm")} ${i18n.t("adalahdiperlukan")}`
        } else {
          this.msgkemaskiniRM = []
        }

        // if (this.kemaskiniketerangankoditem !== "00000000") {
        //   if (parseInt(this.kemaskiniRM) !== 0) {
        //     vali++
        //     this.msgkemaskiniRM = `${i18n.t("rm")} ${i18n.t("perludiisinilaiyangbetul")}`
        //   } else {
        //     this.msgkemaskiniRM = []
        //   }
        // }

        if (this.kemaskiniketerangankoditem !== "00000000" && parseFloat(this.kemaskiniRM) === 0 || 
            this.kemaskiniketerangankoditem === "00000000" && parseFloat(this.kemaskiniRM) !== 0) {
            vali++;
          this.msgkemaskiniRM = `${i18n.t("rm")} ${i18n.t("perludiisinilaiyangbetul")}`;
        } else {
          this.msgkemaskiniRM = [];
        }

        
        if (vali === 0) {
          await axios
            .post(`${process.env.VUE_APP_API_URL}/blk/kemaskiniblok4b`, datakemaskini)
            .then((result) => {
              if (result.data.result === 1) {
                this.snackbar = {
                  message: i18n.t("berjaya"),
                  timeout: 2000,
                  color: "success",
                  show: true,
                  icon: "check_circle",
                };
                this.cariblok4b();
                this.modalkemaskiniblok4b = false;
              } else {
                this.snackbar = {
                  message: i18n.t("cubalagi"),
                  timeout: 2000,
                  color: "red darken-4",
                  show: true,
                  icon: "error_outline",
                };
            }
          });
        } else {
        this.msgkemaskiniRM = `${i18n.t("rm")} ${i18n.t("adalahdiperlukan")}`
        }
       }
    },
    async padam(kemaskiniBil){
      
          try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/blk/deleteBlok4b`, {
                kemaskiniBil: kemaskiniBil,
              })
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Berjaya Dipadam!'
                this.noairClick=false;
                this.modalkemaskiniblok4b = false;
                this.cariblok4b();
            } catch (error) {
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Padam : '+error;
            }
    },
    async btnmodalkemaskiniblok4b(row) {
      this.modalkemaskiniblok4b = true;
      try {
        await axios
          .post(`${process.env.VUE_APP_API_URL}/blk/paparrowdatablok4b`, {
            blok4bbil: row.Bil,
          })
          .then((result) => {
            const namaunit = this.paparketeranganitem.filter(el => el.KodItem === result.data.data.KodItem)
            this.kemaskiniBil = result.data.data.Bil;
            this.kemaskinikoditem = result.data.data.KodItem;
            this.kemaskiniketerangankoditem = result.data.data.KodItem;
            this.kemaskiniketerangan = result.data.data.Keterangan;
            this.kemaskinijenisbarang = result.data.data.JenisBarang;
            this.kemaskiniRM = result.data.data.RMNEG;
            this.kemaskinikuantiti = result.data.data.Kuantiti;
            this.kemaskiniunit = `${result.data.data.Unit} - ${namaunit[0].namaUnit}`;
            this.kemaskinihargasebenar = result.data.data.SebenarAnggaran;
            this.kemaskinipuncalokasi = result.data.data.PuncaPembelian;
            this.kemaskinimediumpembayaran = result.data.data.MediumBayaran;
            this.kemaskinibulan = `${result.data.data.Bulan} - ${result.data.data.Tahun}`;
            this.kemaskiniedagang = result.data.data.eDagang;
            this.kemaskinicatatan = result.data.data.Catatan;
            this.Ind = result.data.data.Ind;
            this.paparinputblok4b = true;

          });
      } catch (err) {
        console.log(err);
      }
    },
    papareDagang(id) {
      let eDagang = "";
      lookup.getEdagang().forEach(async function (element) {
        if (id === element.id) {
          eDagang = element.desc;
        }
      });
      return eDagang;
    },
    paparpuncalokasi(id) {
      let puncalokasi = "";
      lookup.getPuncalokasi().forEach(async function (element) {
        if (id === element.id) {
          puncalokasi = element.desc;
        }
      });
      return puncalokasi;
    },
    paparsebenaranggaran(id) {
      let sebenaranggaran = "";
      lookup.getHargasebenaranggaran().forEach(async function (element) {
        if (id === element.id) {
          sebenaranggaran = element.desc;
        }
      });
      return sebenaranggaran;
    },
    paparmediumbayaran(id) {
      let mediumpembayaran = "";
      lookup.getMediumpembayaran().forEach(async function (element) {
        if (id === element.id) {
          mediumpembayaran = element.desc;
        }
      });
      return mediumpembayaran;
    },

    async btntambahkoditem() {
      if (this.$refs.formtambahblok4b.validate()) {
        const tambahblok4b = {
          blok4bhid: this.blok4bhid,
          bulan: this.bulan.bulan,
          tambahtahun: this.bulan.tahun,
          tambahketerangankoditem: this.tambahketerangankoditem,
          tambahketerangan: this.tambahketerangan,
          tambahjenisbarang: this.tambahjenisbarang,
          tambahRM: this.RMNEG,
          tambahRM_HQ: this.RMHQ,
          tambahkuantiti: this.tambahkuantiti,
          tambahunit: this.tambahunit,
          tambahhargasebenar: this.tambahhargasebenar,
          tambahpuncalokasi: this.tambahpuncalokasi,
          tambahmediumpembayaran: this.tambahmediumpembayaran,
          tambahedagang: this.tambahedagang,
          tambahcatatan: this.tambahcatatan,
          Ind: this.Ind
        };
        this.showOverlay = true;
      
        let vali = 0
        if (this.tambahRM === '') {
          vali++
          this.msgtambahRM = `${i18n.t("rm")} ${i18n.t("adalahdiperlukan")}`
        } else {
          this.msgtambahRM = []
        }

        // if (this.tambahketerangankoditem !== "00000000") {
        //   if (parseInt(this.tambahRM) !== 0) {
        //     vali++
        //     this.msgtambahRM = `${i18n.t("rm")} ${i18n.t("perludiisinilaiyangbetul")}`
        //   } else {7
        //     this.msgtambahRM = []
        //   }
        // }

        if ((this.tambahketerangankoditem !== "00000000" && parseFloat(this.tambahRM) === 0) 
              || (this.tambahketerangankoditem == "00000000" && parseFloat(this.tambahRM) !== 0)) {
              vali++;
              this.msgtambahRM = `${i18n.t("rm")} ${i18n.t("perludiisinilaiyangbetul")}`;
        } else {
          this.msgtambahRM = [];
        }

        if (vali === 0) {
        await axios
          .post(
            `${process.env.VUE_APP_API_URL}/blk/masukdatablok4b`,
            tambahblok4b
          )
          .then((res) => {
            this.showOverlay = false;
            console.log(res.data.status);
            if (res.data.status) {
              this.$store.dispatch("setSnackbar", {
                showing: true,
                color: "green white white--text",
                text: i18n.t("berjaya"),
                timeout: 2000,
              });
              this.resetpaparformtambahblok4b();
              this.cariblok4b();
            } else {
              this.$store.dispatch("setSnackbar", {
                showing: true,
                text: i18n.t("cubalagi"),
                timeout: 2000,
             });
              }
          });
        } else {
          this.showOverlay = false;
        }
      } else {
        this.msgtambahRM = `${i18n.t("rm")} ${i18n.t("adalahdiperlukan")}`
      }
    },

    async getData(){
        //dapatkan data dari table tapispusingan based on pusingan
        try {
            const res = await axios.get(`${process.env.VUE_APP_API_URL}/HES/getDataBulan?pusingan=`+this.blok4bpusingan +`&tahun=`+this.blok4btahun, {
            //const res = await axios.get(`${process.env.VUE_APP_API_URL}/HES/getDataBulan?pusingan=06`, {
            })
            
            this.dataPusingan = res.data.data;
            this.bulan(this.dataPusingan)
            
          } catch (error) {
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'getData : '+ error;
          }
      },

    async tukarkecurrentcy() {
      // console.log(this.tambahRM.length);
      // if (this.tambahRM.length >= 4) {
      //   const numberFormatter = new Intl.NumberFormat("de-DE", {
      //     maximumSignificantDigits: 3,
      //   });
      //   console.log(numberFormatter.format(this.tambahRM));
      //   this.tambahRM = numberFormatter.format(this.tambahRM);
      // }
    },
    async isidatakoditem(mode) {
      try {
        let koditem = "";
        let jenisbarang = "";
        let keterangan = "";
        let unit = "";
        let namaUnit = "";
        let Ind = "";

        if (mode === "tambah") {
          koditem = this.tambahketerangankoditem;
        } else if (mode === "kemaskini") {
          koditem = this.kemaskiniketerangankoditem;
        }
        this.paparketeranganitem.forEach(async function (element) {
          if (koditem === element.KodItem) {
            jenisbarang = element.JenisBarang;
            keterangan = element.Keterangan;
            unit = element.Unit + " - "+ element.namaUnit;
            Ind = element.Ind;
            
          }
        });
        if (mode === "tambah") {
          this.tambahketerangan = keterangan;
          this.tambahkoditem = koditem;
          this.tambahjenisbarang = jenisbarang;
          this.tambahunit = unit + namaUnit;
          this.Ind = Ind;
          this.paparinputblok4b = true;
          this.tambahcatatan = "-";
        } else if (mode === "kemaskini") {
          this.kemaskiniketerangan = keterangan;
          this.kemaskinijenisbarang = jenisbarang;
          this.paparinputblok4b = true;
          this.kemaskinikoditem = koditem;
          this.kemaskiniunit = unit + namaUnit;
          this.Ind = Ind;
        }
      } catch (err) {
        alert(err);
      }
    },
    async paparanpermulaan() {
      try {
        if (typeof this.$route.params.hid !== "undefined"){
          await axios
          .get(
            `${process.env.VUE_APP_API_URL}/auth/decode?de=${this.$route.params.hid}`
          )
          .then((result) => {
            this.blok4bhid = result.data.decode;
            const jr2 = {
              hidjr2: this.blok4bhid,
            };
            axios
              .post(`${process.env.VUE_APP_API_URL}/JR/papardatajr2`, jr2)
              .then((res) => {
                this.blok4btahun = res.data.data.TAHUN;
                this.blok4bpusingan = res.data.data.P;
                this.mindate = `${this.blok4btahun}-01-01`;
                this.maxday = `${this.blok4btahun}-12-31`;
                this.cariblok4b()
                this.getData()
              });
          });
        } else {
           this.$router.push(`/${i18n.locale}/heshid`, () => {});
        }
      } catch (err) {
        console.log(err);
        if (err.response.data.msg === "errordecode") {
          this.$router.push(`/${i18n.locale}/heshid`, () => {});
        }
      }
    },
    async cariblok4b() {
      try {
        const caridatablok4b = {
          blok4bhid: this.blok4bhid,
          //tahunbulanhari: this.tahunbulanhari,
        };
        await axios
          .post(
            `${process.env.VUE_APP_API_URL}/blk/caridatablok4b`,
            caridatablok4b
          )
          .then((result) => {
            this.papardatablok4b = result.data.data;
            this.bulan = this.papardatablok4b.Bulan;
            let jumharian = 0;
            let jumedagang = 0;
            let jumkeseluruhan = 0;
            result.data.data.forEach(async function (element) {
              if (element.eDagang === "1") {
                jumedagang += parseFloat(element.RMNEG);
                jumkeseluruhan += parseFloat(element.RMNEG);
              } else {
                jumharian += parseFloat(element.RMNEG);
                jumkeseluruhan += parseFloat(element.RMNEG);
              }
            });
            this.jumlahedagang = jumedagang.toFixed(2);
            this.jumlahharian = jumharian.toFixed(2);
            this.jumlahkeseluruhan = jumkeseluruhan.toFixed(2);
          });
      } catch (err) {
        alert(err);
      }
    },
    async mingguanberdasarknhari(hari) {
      if (hari >= 1 && hari <= 7) {
        this.blok4bmingguan = "1";
      }
      if (hari >= 4 && hari <= 14) {
        this.blok4bmingguan = "2";
      }
      if (hari >= 15 && hari <= 21) {
        this.blok4bmingguan = "3";
      }
      if (hari >= 22 && hari <= 28) {
        this.blok4bmingguan = "4";
      }
      if (hari >= 29 && hari <= 31) {
        this.blok4bmingguan = "5";
      }
    },

    async btnmodaltambahblok4b() {
      this.modaltambahblok4b = true;
    },
    async resetpaparformtambahblok4b() {
      //this.paparlookupketeranganitem = false;
      this.paparinputblok4b = false;
      this.$refs.formtambahblok4b.resetValidation();
      this.$refs.formtambahblok4b.reset();
    },

    async papardatakoditem(mode) {
      try {
        let papardatakoditem = "";
        if (mode === "tambah") {
          papardatakoditem = this.tambahkoditem;
        } else if (mode === "kemaskini") {
          papardatakoditem = this.kemaskinikoditem;
        }
        if (papardatakoditem.length >= 4) {
            const datakoditem = {
            koditem: papardatakoditem,
          };
          await axios
            .post(
              `${process.env.VUE_APP_API_URL}/blk/paparkoditem4b`,
              datakoditem
            )
            .then((res) => {
              this.paparketeranganitem = res.data.data;
            });
          this.paparlookupketeranganitem = true;
        } else {
          this.paparlookupketeranganitem = false;
          this.paparketeranganitem = [];
          this.paparlookupketeranganitem = false;
          this.paparinputblok4b = false;
        }
      } catch (err) {
        alert(err);
      }
    },
  },
  watch: {
     tambahRM(val){
        if (this.Ind == 1){
        this.RMNEG = Number(this.tambahRM);
        this.RMHQ = Number(this.tambahRM) / 12;
      }else{
        this.RMHQ = Number(this.tambahRM);
        this.RMNEG = Number(this.tambahRM);
      }
    },
    kemaskiniRM(val){
        if (this.Ind == 1){
        this.RMNEG = Number(this.kemaskiniRM);
        this.RMHQ = Number(this.kemaskiniRM) / 12;
      }else{
        this.RMHQ = Number(this.kemaskiniRM);
        this.RMNEG = Number(this.kemaskiniRM);
      }
    },
    tahunbulanhari(val) {
      const [tahun, bulan, hari] = val.split("-");
      tahun;
      bulan;
      this.mingguanberdasarknhari(hari);
      this.paparbtn = true;
    },

    tambahketerangankoditem(val) {
      if (this.tambahketerangankoditem == 0) {
          this.tambahRM ='0';
          this.tambahkuantiti ='0';
          this.tambahhargasebenar ='0';
          this.tambahpuncalokasi ='00';
          this.tambahmediumpembayaran ='00';
          this.tambahedagang ='0';
          this.bulan = '00';
          this.tambahtahun = '0000';
        } else if (this.tambahketerangankoditem != 0) {
          this.tambahRM ='';
          this.tambahkuantiti ='';
          this.tambahhargasebenar ='';
          this.tambahpuncalokasi ='';
          this.tambahmediumpembayaran ='';
          this.tambahedagang =''; 
          this.bulan = '';
          this.tambahtahun = '';
      }
    },
    
    kemaskiniketerangankoditem(val) {
      if (this.kemaskiniketerangankoditem == 0) {
     this.kemaskiniRM ='0';
     this.kemaskinikuantiti ='0';
     this.kemaskinihargasebenar ='0';
     this.kemaskinipuncalokasi ='00';
     this.kemaskinimediumpembayaran ='00';
     this.kemaskiniedagang ='0';
     this.kemaskinibulan = '00';
     this.kemaskinitambahtahun = '0';
      }
    },

    bulan(dataz){
      console.log(this.dataPusingan)
      //lookup bulan dari db - step 1
      var bulanMula = new Date(this.dataPusingan[0].bulanMula);
      var bulanAkhir = new Date(this.dataPusingan[0].bulanAkhir);
      
      const fromYear = bulanMula.getFullYear();
      const fromMonth = bulanMula.getMonth();
      const toYear = bulanAkhir.getFullYear();
      const toMonth = bulanAkhir.getMonth();

      for(let year = fromYear; year <= toYear; year++) {
          let monthNum = year === fromYear ? fromMonth : 0;
          const monthLimit = year === toYear ? toMonth : 11;

          for(; monthNum <= monthLimit; monthNum++) {
              let month = monthNum + 1;
              month = String(month).padStart(2, '0');
              this.listBulan.push({ "tahun":year, "bulan":month });
          }
      }
      console.log(this.listBulan)
    },

    kemaskinibulan(dataz){
      console.log(this.dataPusingan)
      //lookup bulan dari db - step 1
      var bulanMula = new Date(this.dataPusingan[0].bulanMula);
      var bulanAkhir = new Date(this.dataPusingan[0].bulanAkhir);
      
      const fromYear = bulanMula.getFullYear();
      const fromMonth = bulanMula.getMonth();
      const toYear = bulanAkhir.getFullYear();
      const toMonth = bulanAkhir.getMonth();

      for(let year = fromYear; year <= toYear; year++) {
          let monthNum = year === fromYear ? fromMonth : 0;
          const monthLimit = year === toYear ? toMonth : 11;

          for(; monthNum <= monthLimit; monthNum++) {
              let month = monthNum + 1;
              month = String(month).padStart(2, '0');
              this.listBulan.push({ "tahun":year, "bulan":month });
          }
          //console.log(this.listBulan)
      }
      console.log(this.listBulan)
    },
  },
};
</script> 